window.dn = window.dn || {};
dn.Crypto = (window.crypto || window.msCrypto).subtle;

(function (crypto, $, undefined)
{
    /**
     * This uses AES-GCM to encrypt the passed data, and returns the encrypted data 'cipher'
     * as well as the initialization vector which was used to encrypt it (iv). The iv is required
     * for proper decrypting - it is not sensitive information.
     * 
     * @param {object} data - The data to encrypt
     */
    // TODO: async function not compatible with older browsers.
    // crypto.Encrypt = async function(data) {
    //     const key = await crypto.LoadKey();
    //     const encoded = new TextEncoder().encode(data);
    //     const iv = generateIv();
    //     const cipher = await dn.Crypto.encrypt(
    //         {
    //             name: 'AES-GCM',
    //             iv: iv,
    //         }, 
    //         key, 
    //         encoded);

    //     return { cipher, iv }
    // };

    /**
     * This uses AES-GCM to decrypt the passed data, and returns the result
     * 
     * @param {string} cipher - The encrypted data
     * @param {string} iv - The initialization vector which was used to encrypt the data
     */
    // TODO: async function not compatible with older browsers.
    // crypto.Decrypt = async function(cipher, iv) 
    // {
    //     try
    //     {
    //         const key = await crypto.LoadKey()
    //         const encoded = await dn.Crypto.decrypt(
    //             {
    //                 name: 'AES-GCM',
    //                 iv: iv,
    //             }, 
    //             key, 
    //             cipher);
    //         return new TextDecoder().decode(encoded);
    //     }
    //     catch(e)
    //     {
    //         console.debug(e)
    //         return ""
    //     }        
    // };

    // Creates a random initialization vector
    const generateIv = function () 
    {
        return window.crypto.getRandomValues(new Uint8Array(16))
    }

    /**
     * This uses AES-GCM to decrypt the passed data, and returns the result
     * 
     * @param {string} cipher - The encrypted data
     * @param {string} iv - The initialization vector which was used to encrypt the data
     */
    // TODO: async function not compatible with older browsers.
    // crypto.LoadKey = async function() 
    // {
    //     let importedKey = await dn.Crypto.importKey(
    //         "raw", 
    //         crypto.StringToArrayBuffer(dn.user.UserHash), 
    //         {name: "PBKDF2"}, 
    //         false, 
    //         ["deriveBits", "deriveKey"]
    //       );

    //     return await dn.Crypto.deriveKey(
    //         {
    //         "name": "PBKDF2",
    //         salt: crypto.StringToArrayBuffer(dn.user.UserKey),
    //         "iterations": 100000,
    //         "hash": "SHA-256"
    //         },
    //         importedKey,
    //         { "name": "AES-GCM", "length": 256},
    //         true,
    //         [ "encrypt", "decrypt" ]
    //     );
    // };


    // Takes a String and converts it to an ArrayBuffer for storage
    crypto.StringToArrayBuffer = function(data) 
    {
        const string = window.atob(data)
        const buffer = new ArrayBuffer(string.length)
        const bufferView = new Uint8Array(buffer)

        for (let i = 0; i < string.length; i++) {
            bufferView[i] = string.charCodeAt(i)
        }

        return buffer
    };


}(window.dn.crypto = window.dn.crypto || {}, jQuery));


